import AbstractListenerAction from "~/ts/library/listen/AbstractListenerAction";
import OperatorApplicationAutomaticTemplates
    from "~/operatorApplication/ts/service/dialog/OperatorApplicationAutomaticTemplates";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";

export default class ResetAutoTemplates extends AbstractListenerAction {
    public getAction(): string {
        return "resetAutoTemplates";
    }

    public onAction(payload: CometOperatorApplication.ResetAutoTemplatesCometMessageOpenApiModel): void {
        if (OperatorAccountStore.isAuthorized.value) {
            OperatorApplicationAutomaticTemplates.fetchFromServer();
        }
    }
}


/*
{"id":1,"channel":"14755221258159fdb93bdc95487328cc4cc83208","text":{"action":"editMessage","id":184744097,"text":"в пердакшен!"},"time":"1561049769050","tag":0}
 */